var map = {
	"./epl/Arsenal.png": 50703,
	"./epl/Aston-Villa.png": 84157,
	"./epl/Bournemouth.png": 92941,
	"./epl/Brighton.png": 30382,
	"./epl/Burnley.png": 79342,
	"./epl/Chelsea.png": 34354,
	"./epl/Crystal-Palace.png": 92398,
	"./epl/Everton.png": 82926,
	"./epl/Fulham.png": 1304,
	"./epl/Leicester.png": 29619,
	"./epl/Liverpool.png": 89187,
	"./epl/Manchester-City.png": 93395,
	"./epl/Manchester-Utd.png": 72001,
	"./epl/Newcastle.png": 21623,
	"./epl/Southampton.png": 84275,
	"./epl/Tottenham.png": 20129,
	"./epl/West-Ham.png": 17781,
	"./epl/Wolves.png": 3013,
	"./epl/_EPL.png": 29969,
	"./mlb/Arizona-Diamondbacks.png": 47678,
	"./mlb/Atlanta-Braves.png": 46744,
	"./mlb/Baltimore-Orioles.png": 8750,
	"./mlb/Boston-Red-Sox.png": 91835,
	"./mlb/Chicago-Cubs.png": 65467,
	"./mlb/Chicago-White-Sox.png": 70450,
	"./mlb/Cincinnati-Reds.png": 9212,
	"./mlb/Cleveland-Guardians.png": 99678,
	"./mlb/Colorado-Rockies.png": 41797,
	"./mlb/Detroit-Tigers.png": 91493,
	"./mlb/Houston-Astros.png": 16260,
	"./mlb/Kansas-City-Royals.png": 45063,
	"./mlb/Los-Angeles-Angels.png": 58502,
	"./mlb/Los-Angeles-Dodgers.png": 53498,
	"./mlb/Miami-Marlins.png": 53649,
	"./mlb/Milwaukee-Brewers.png": 12320,
	"./mlb/Minnesota-Twins.png": 24897,
	"./mlb/New-York-Mets.png": 92001,
	"./mlb/New-York-Yankees.png": 64694,
	"./mlb/Oakland-Athletics.png": 65863,
	"./mlb/Philadelphia-Phillies.png": 3671,
	"./mlb/Pittsburgh-Pirates.png": 83076,
	"./mlb/San-Diego-Padres.png": 64118,
	"./mlb/San-Francisco-Giants.png": 37145,
	"./mlb/Seattle-Mariners.png": 91141,
	"./mlb/St-Louis-Cardinals.png": 33173,
	"./mlb/Tampa-Bay-Rays.png": 46553,
	"./mlb/Texas-Rangers.png": 26777,
	"./mlb/Toronto-Blue-Jays.png": 20261,
	"./mlb/Washington-Nationals.png": 44983,
	"./mlb/_MLB.png": 85621,
	"./mls/Atlanta-Utd.png": 42297,
	"./mls/Austin.png": 33062,
	"./mls/CF-Montreal.png": 33424,
	"./mls/Charlotte.png": 39318,
	"./mls/Chicago-Fire.png": 30969,
	"./mls/Colorado-Rapids.png": 85233,
	"./mls/Columbus-Crew.png": 77986,
	"./mls/DC-United.png": 66739,
	"./mls/FC-Cincinnati.png": 56350,
	"./mls/FC-Dallas.png": 81837,
	"./mls/Houston-Dynamo.png": 86397,
	"./mls/Inter-Miami.png": 41350,
	"./mls/LA-Angeles-FC.png": 34585,
	"./mls/LA-Galaxy.png": 2648,
	"./mls/Minnesota-Utd.png": 20776,
	"./mls/NY-Red-Bulls.png": 80944,
	"./mls/NYCFC.png": 3985,
	"./mls/Nashville.png": 32088,
	"./mls/New-England.png": 58920,
	"./mls/Orlando-City.png": 1009,
	"./mls/Philadelphia.png": 78993,
	"./mls/Portland-Timbers.png": 14557,
	"./mls/Real-Salt-Lake.png": 43835,
	"./mls/San-Jose.png": 3378,
	"./mls/Seattle.png": 66834,
	"./mls/Sporting-KC.png": 73911,
	"./mls/St-Louis.png": 86258,
	"./mls/Toronto-FC.png": 33585,
	"./mls/Vancouver.png": 34907,
	"./mls/_MLS.png": 33691,
	"./nba/Atlanta.png": 63468,
	"./nba/Boston.png": 51494,
	"./nba/Brooklyn.png": 98999,
	"./nba/Charlotte.png": 35865,
	"./nba/Chicago.png": 18693,
	"./nba/Cleveland.png": 69027,
	"./nba/Dallas.png": 1820,
	"./nba/Denver.png": 87485,
	"./nba/Detroit.png": 41988,
	"./nba/Golden-State.png": 88498,
	"./nba/Houston.png": 36239,
	"./nba/Indiana.png": 73887,
	"./nba/LA-Clippers.png": 35581,
	"./nba/LA-Lakers.png": 10763,
	"./nba/Memphis.png": 15206,
	"./nba/Miami.png": 39552,
	"./nba/Milwaukee.png": 10757,
	"./nba/Minnesota.png": 73161,
	"./nba/New-Orleans.png": 57386,
	"./nba/New-York.png": 64983,
	"./nba/Oklahoma.png": 1763,
	"./nba/Orlando-Magic.png": 22584,
	"./nba/Philadelphia.png": 67816,
	"./nba/Phoenix.png": 87700,
	"./nba/Portland.png": 14963,
	"./nba/Sacramento.png": 99642,
	"./nba/San-Antonio.png": 95408,
	"./nba/Toronto.png": 56642,
	"./nba/Utah.png": 12433,
	"./nba/Washington.png": 42995,
	"./nba/_NBA.png": 38213,
	"./nfl/Arizona.png": 3436,
	"./nfl/Atlanta.png": 45769,
	"./nfl/Baltimore.png": 32831,
	"./nfl/Buffalo.png": 80515,
	"./nfl/Carolina.png": 45129,
	"./nfl/Chicago.png": 57780,
	"./nfl/Cincinnati.png": 42692,
	"./nfl/Cleveland.png": 50498,
	"./nfl/Dallas.png": 15651,
	"./nfl/Denver.png": 15910,
	"./nfl/Detroit.png": 75673,
	"./nfl/Green-Bay.png": 9610,
	"./nfl/Houston.png": 61974,
	"./nfl/Indianapolis.png": 88289,
	"./nfl/Jacksonville.png": 51691,
	"./nfl/Kansas-City.png": 8659,
	"./nfl/LA-Chargers.png": 53655,
	"./nfl/LA-Rams.png": 21797,
	"./nfl/Las-Vegas.png": 87121,
	"./nfl/Miami.png": 94105,
	"./nfl/Minnesota.png": 44912,
	"./nfl/NY-Giants.png": 1002,
	"./nfl/NY-Jets.png": 66144,
	"./nfl/New-England.png": 34598,
	"./nfl/New-Orleans.png": 33623,
	"./nfl/Philadelphia.png": 47871,
	"./nfl/Pittsburgh.png": 79680,
	"./nfl/San-Francisco.png": 27667,
	"./nfl/Seattle.png": 71024,
	"./nfl/Tampa-Bay.png": 41052,
	"./nfl/Tennessee.png": 45326,
	"./nfl/Washington.png": 4700,
	"./nfl/_NFL.png": 40235,
	"./nhl/Anaheim.png": 34895,
	"./nhl/Boston.png": 22419,
	"./nhl/Buffalo.png": 19521,
	"./nhl/Calgary.png": 40189,
	"./nhl/Carolina.png": 48003,
	"./nhl/Chicago.png": 63458,
	"./nhl/Colorado.png": 78365,
	"./nhl/Columbus.png": 15382,
	"./nhl/Dallas.png": 70857,
	"./nhl/Detroit.png": 60647,
	"./nhl/Edmonton.png": 62330,
	"./nhl/Florida.png": 10501,
	"./nhl/Los-Angeles.png": 56000,
	"./nhl/Minnesota.png": 93422,
	"./nhl/Montreal.png": 23150,
	"./nhl/NY-Islanders.png": 45797,
	"./nhl/NY-Rangers.png": 47542,
	"./nhl/Nashville.png": 9456,
	"./nhl/New-Jersey.png": 20571,
	"./nhl/Ottawa.png": 61464,
	"./nhl/Philadelphia.png": 33545,
	"./nhl/Pittsburgh.png": 38458,
	"./nhl/San-Jose.png": 48810,
	"./nhl/Seattle.png": 18666,
	"./nhl/St-Louis.png": 85418,
	"./nhl/Tampa-Bay.png": 83606,
	"./nhl/Toronto.png": 17709,
	"./nhl/Vancouver.png": 57027,
	"./nhl/Vegas.png": 22604,
	"./nhl/Washington.png": 43198,
	"./nhl/Winnipeg.png": 33843,
	"./nhl/_NHL.png": 23675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85386;